// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"_2CopC"};